import * as React from 'react';

import FileBookmark16 from './FileBookmark16';

export const fileBookmark16 = () => <FileBookmark16 />;

export default {
    title: 'Icon/Fill/FileBookmark16',
    component: FileBookmark16,
    parameters: {
        notes: "`import FileBookmark16 from 'box-ui-elements/es/icon/fill/FileBookmark16';`",
    },
};
